// extracted by mini-css-extract-plugin
module.exports = {"stylesButton":"jd2CdFnc","stylesXsButton":"C8Wo2Ajr","styledDropdownMenu":"ByGKLzxB","select":"MqdR4V6d","selectWrapper":"pGvZ9_Di","optionWrapper":"xhqwRu77","label":"fMOnSGAl"};